/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:28
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-04 14:07:38
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  DatePicker,
  Checkbox,
  Input,
} from 'antd'
import { unwatchFile } from 'fs'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTenantId, selectChainId, selectChainType } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import {
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../../compnents/form/DateSelect'
import {
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormat,
} from '../../../models/datetime'
import { getChainTenantListFn } from '../../chainTransferApplication/chainSlice'
import styles from './EAFUse.module.css'
const { Option } = Select

export const Query = (props: {
  add: () => void
  onValueChange: (params: any) => void
  export: () => void
  exportLoading?: any
  loading?: any
}): ReactElement => {
  const [form] = Form.useForm()

  const { RangePicker } = DatePicker

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const chainType = useSelector(selectChainType)

  const [chainList, setChainList] = useState<any>([])

  useEffect(() => {
    if (tenantId == chainId) {
      dispatch(getChainTenantListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.records)
        })
    }
  }, [])
  
  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      autoComplete='off'
      form={form}
      onFinish={(values) => {
        if(!values?.timeHead && values?._dateRange == 6){
          return
        }
        const startTime = values?.timeHead
          ? moment(values?.timeHead)?.format(DateTimeFormat)
          : undefined
        const endTime = values?.timeTail
          ? moment(values?.timeTail)?.format(DateTimeFormat)
          : undefined
        props.onValueChange({
          ...values,
          startTimeStart: startTime,
          startTimeEnd: endTime,
          timeHead: undefined,
          timeTail: undefined,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10, width: '100%' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <DateSelect
            style={{ width: '8rem' }}
            labelPrefix=''
            placeholder='启动日期'
            namePrefix='time'
            onChange={() => {
              form.submit()
            }}
          />
          <Form.Item name='deviceNumber' noStyle>
            <Input
              allowClear={true}
              placeholder='设备编号'
              style={{ width: '8rem' }}
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='deviceName' noStyle>
            <Input
              allowClear={true}
              placeholder='设备名称'
              style={{ width: '8rem' }}
              onChange={() => {
                form.submit()
              }}
            />
          </Form.Item>
          {(tenantId == chainId && chainType >= 0) ? (
            <Form.Item name='tenantId' noStyle>
              <Select
                placeholder={'选择门店'}
                allowClear
                showSearch
                dropdownClassName={styles.selects}
                style={{ width: '16rem' }}
                optionFilterProp='children'
                onChange={form.submit}
              >
                {chainList?.map((v: any, i: any) => {
                  return (
                    <Option value={v.id} key={i}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            ''
          )}
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            onClick={() => {
              props?.add && props?.add()
            }}
          >
            添加
          </Button>
          {/* <Button
            loading={props?.exportLoading}
            type='primary'
            onClick={() => {
              props?.export && props?.export()
            }}
          >
            导出
          </Button> */}
        </Space>
      </Row>
    </Form>
  )
}
